import { createFileRoute } from "@tanstack/react-router";
import AdminEmailMismatches from "@/pages/AdminEmailMismatches";

export const Route = createFileRoute("/admin/email-mismatches/")({
  component: AdminEmailMismatches,
});
